// import './bannerAd.style.scss';

export const TYPE_POSITION_CONFIG = {
  home_top: {
    code: 'home_top',
    styles: {
      width: 728,
      maxWidth: '100%',
      // height: '120',

      background: '#FFFFFF',
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/home_top_masthead',
      sizes: [728, '100%'],
    },
    ratio: '728:90'
  },
  home_left_scroll_up: {
    code: 'home_left_scroll_up',
    styles: {
      width: 120,
      maxWidth: 120,
      maxHeight: 600,
      position: 'sticky',
      overflow: 'hidden',
      top: 100,
    },
    device_types: ['desktop'],
    adManager: {
      id: '/40383301/home_left_scrollup',
      sizes: [160, 600],
    },
    ratio: '120:600'
  },
  home_right_scroll_up: {
    code: 'home_right_scroll_up',
    styles: {
      width: 120,
      maxWidth: 120,
      maxHeight: 600,
      position: 'sticky',
      overflow: 'hidden',
      float: 'right',
      top: 100,
    },
    device_types: ['desktop'],
    adManager: {
      id: '/40383301/home_right_scrollup',
      sizes: [160, 600],
    },
    ratio: '120:600'
  },
  layout_popup: {
    code: 'layout_popup',
    styles: {
      width: 662,
      maxWidth: '100%',
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/home_popup',
      sizes: [660, 400],
    },
    ratio: '660:400'
  },
  articles_banner_a: {
    code: 'articles_banner_a',
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/article_banner_a',
      sizes: [728, '100%'],
    },
    styles: {
      maxWidth: '728px',
      margin: '0 auto',
    },
    ratio: '728:90'
  },
  articles_banner_b: {
    code: 'articles_banner_b',
    styles: {
      width: 284,
      maxWidth: '100%',
      // height: 142
      margin: '0 auto',
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/article_banner_b',
      sizes: [284, 142],
    },
    ratio: '728:90'
  },
  articles_banner_c: {
    code: 'articles_banner_c',
    styles: {
      width: 300,
      maxWidth: '100%',
      margin: '0 auto',
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/article_banner_c',
      sizes: [300, 300],
    },
    ratio: '1:1'
  },
  articles_inside_article: {
    code: 'articles_inside_article',
    styles: {
      width: 570,
      maxWidth: '100%',
      marginBottom: '10px',
      // height: 570
    },
    device_types: ['mobile'],
    adManager: {
      id: '/40383301/mb_inside_article',
      sizes: [415, 670],
    },
    ratio: '300:600'
  },
  home_top_slider: {
    code: 'home_top_slider',
    device_types: ['desktop', 'mobile'],
    styles: {
      width: 892,
      maxWidth: '100%',
    },
    ratio: '892:448'
  },
  home_mid_1: {
    code: 'home_mid_1',
    styles: {
      maxWidth: '600px',
      margin: '0 auto',
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/home_mid_1',
      sizes: [600, 90],
    },
    ratio: '728:90'
  },
  home_mid_2: {
    code: 'home_mid_2',
    styles: {
      maxWidth: '600px',
      margin: '0 auto',
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/home_mid_2',
      sizes: [600, 90],
    },
  },
  home_mid_3: {
    code: 'home_mid_3',
    styles: {
      maxWidth: '600px',
      margin: '0 auto',
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/home_mid_3',
      sizes: [600, 90],
    },
  },
  articles_footer_article: {
    code: 'articles_footer_article',
    // styles: {
    //   maxWidth: '100%',
    // },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/articles_footer_article',
      sizes: [728, 90],
    },
    ratio: '728:90',
    styles: {
      maxWidth: '728px',
      margin: '0 auto',
    },
  },
  articles_academy_footer_article: {
    code: 'articles_academy_footer_article',
    styles: {
      maxWidth: '100%',
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/article_academy_footer',
      sizes: [583, 189],
    },
  },
  home_featured: {
    code: 'home_featured',
    styles: {
      width: 300,
      maxWidth: '100%',
      background: '#FFFFFF',
      margin: '0 auto',
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/home_featured',
      sizes: [300, '100%'],
    },
    ratio: '300:250'
  },
  home_broker_a: {
    code: 'home_broker_a',
    styles: {
      width: 320,
      display: 'flex',
      justifyContent: 'center',
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/home_broker_a',
      sizes: [320, 50],
      // styleStr: 'width: 320px',
      style: { width: 320, height: 50 },
    },
    ratio: '320:50'
  },
  home_broker_b: {
    code: 'home_broker_b',
    styles: {
      width: 320,
      display: 'flex',
      justifyContent: 'center',
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/home_broker_b',
      sizes: [320, 50],
      // styleStr: 'width: 320px',
      style: { width: 320, height: 50 },
    },
    ratio: '320:50'
  },
  triple_banner_top_test: {
    code: 'triple_banner_top_test',
    styles: {
      width: "100%",
      maxWidth: 1140,
      height: 267,
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/triple_banner_top_test',
      sizes: [1140, '100%'],
    },
    ratio: '1140:267'
  },
  triple_banner_left_test: {
    code: 'triple_banner_left_test',
    styles: {
      width: 230,
      maxWidth: 230,
      height: 830,
    },
    device_types: ['desktop'],
    adManager: {
      id: '/40383301/triple_banner_left_test',
      sizes: [230, 830],
    },
    ratio: '230:830'
  },
  triple_banner_right_test: {
    code: 'triple_banner_right_test',
    styles: {
      width: 230,
      maxWidth: 230,
      height: 830,
    },
    device_types: ['desktop'],
    adManager: {
      id: '/40383301/banner_triple_right_test',
      sizes: [230, 830],
    },
    ratio: '230:830'
  },
  header_top_1: {
    code: 'header_top_1',
    styles: {
      width: '100%',
      maxWidth: 345
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/header_top_1',
      sizes: [345, 100],
    },
    ratio: '345:100'
  },
  header_top_2: {
    code: 'header_top_2',
    styles: {
      width: '100%',
      maxWidth: 345,
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/header_top_2',
      sizes: [345, 100],
    },
    ratio: '345:100'
  },
  header_top_3: {
    code: 'header_top_3',
    styles: {
      width: '100%',
      maxWidth: 345,
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/header_top_3',
      sizes: [345, 100],
    },
    ratio: '345:100'
  },
  header_top_4: {
    code: 'header_top_4',
    styles: {
      width: '100%',
      maxWidth: 345,
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/header_top_4',
      sizes: [345, 100],
    },
    ratio: '345:100'
  },
  middle_1: {
    code: 'middle_1',
    styles: {
      width: '100%',
      maxWidth: 345
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/middle_1',
      sizes: [345, 100],
    },
    ratio: '345:100'
  },
  middle_2: {
    code: 'middle_2',
    styles: {
      width: '100%',
      maxWidth: 345,
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/middle_2',
      sizes: [345, 100],
    },
    ratio: '345:100'
  },
  middle_3: {
    code: 'middle_3',
    styles: {
      width: '100%',
      maxWidth: 345,
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/middle_3',
      sizes: [345, 100],
    },
    ratio: '345:100'
  },
  middle_4: {
    code: 'middle_4',
    styles: {
      width: '100%',
      maxWidth: 345,
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/middle_4',
      sizes: [345, 100],
    },
    ratio: '345:100'
  },
  articles_top_1: {
    code: 'articles_top_1',
    styles: {
      width: '100%',
      maxWidth: 360,
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/articles_top_1',
      sizes: [360, 90],
    },
    ratio: '360:90'
  },
  articles_top_2: {
    code: 'articles_top_2',
    styles: {
      width: '100%',
      maxWidth: 360,
    },
    device_types: ['desktop', 'mobile'],
    adManager: {
      id: '/40383301/articles_top_2',
      sizes: [360, 90],
    },
    ratio: '360:90'
  },
};
